module.exports = __webpack_public_path__ + "b9a6efe0765be4c2c29e05c0009b03d6.png";